import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './rootReducer'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import createCompressor from 'redux-persist-transform-compress'
import ReduxThunk from 'redux-thunk'

const compressor = createCompressor()

const persistConfig = {
  key: 'root',
  storage,
  transforms: [compressor],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [ReduxThunk],
  devTools: process.env.NODE_ENV !== 'production',
})

export const persistor = persistStore(store)
